import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';

@Component({
    selector: 'ca-numeric-stepper',
    templateUrl: './numeric-stepper.component.html',
    styleUrls: ['./numeric-stepper.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NumericStepperComponent {
    private readonly defaultNumericMin = 0;
    private readonly defaultNumericMax = 99;
    private readonly defaultNumericStep = 1;
    numericMin = input<number, number | undefined>(this.defaultNumericMin, {
        transform: value => value ?? this.defaultNumericMin
    });
    numericMax = input<number, number | undefined>(this.defaultNumericMax, {
        transform: value => value ?? this.defaultNumericMax
    });
    numericStep = input<number, number | undefined>(this.defaultNumericStep, {
        transform: value => value ?? this.defaultNumericStep
    });
    value = model<number>(0);
    title = input<string>();
    disabled = input<boolean>(false);
    errorMessage = input<string | null>(null);

    step(delta: number): void {
        if (this.disabled()) {
            return;
        }

        this.value.update(current => this.clampValue((current ?? 0) + delta * this.numericStep()));
    }

    onInputChange(event: Event): void {
        if (this.disabled()) {
            return;
        }

        const target = event.target as HTMLInputElement | null;
        if (!target) {
            return;
        }

        const parsed = Number(target?.value ?? '');
        if (Number.isNaN(parsed)) {
            return;
        }

        this.value.set(this.clampValue(parsed));
        // ensure input value stays clamped
        target.value = this.value().toString();
    }

    private clampValue(value: number): number {
        return Math.max(this.numericMin(), Math.min(this.numericMax(), value));
    }
}
